import client from './client';

export interface DailyGrowthPoint {
  date: string;
  count: number;
  cumulative: number;
}

export interface TierBreakdown {
  free: number;
  pro: number;
  institutional: number;
  firm: number;
  enterprise: number;
}

export interface AdminStats {
  totalUsers: number;
  totalUsersGrowthToday: number;
  activeSubscriptions: number;
  freeToPaidPct: number;
  alertsFired7d: number;
  dailyGrowth: DailyGrowthPoint[];
  tierBreakdown: TierBreakdown;
}

export interface FeatureAdoptionEntry {
  feature: string;
  label: string;
  adoptionPct: number;
  usersWithFeature: number;
}

export interface AlertFireRatePoint {
  date: string;
  count: number;
}

export interface AdminAdoption {
  features: FeatureAdoptionEntry[];
  alertFireRate: AlertFireRatePoint[];
  alertFireRate7dAvg: number;
}

export interface TopPage {
  path: string;
  visits: number;
  percentage: number;
}

export async function fetchAdminStats(): Promise<AdminStats> {
  const response = await client.get<AdminStats>('/analytics/admin/stats');
  return response.data;
}

export async function fetchAdminAdoption(): Promise<AdminAdoption> {
  const response = await client.get<AdminAdoption>('/analytics/admin/adoption');
  return response.data;
}

export async function fetchTopPages(): Promise<{ pages: TopPage[] }> {
  const response = await client.get<{ pages: TopPage[] }>('/analytics/admin/top-pages');
  return response.data;
}

export async function trackPageView(path: string): Promise<void> {
  await client.post('/analytics/page-view', { path });
}
